(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-home-field"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const input = document.querySelector('#Search-Inline');
    const container = document.querySelector('.predictive-search--inline');

    if (!input || !container) return;

    input.addEventListener('input', function () {
      const query = input.value.trim();

      if (query.length === 0) {
        container.style.display = 'none';
        container.innerHTML = '';
        return;
      }

      fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=5`
      )
        .then((res) => res.json())
        .then((data) => {
          let html = '<ul>';
          const results = [];

          // Products
          if (data.resources.results.products.length) {
            data.resources.results.products.forEach((p) => {
              results.push(
                `<li onclick="window.location='${p.url}'">
                <img src="${p.image ? p.image : ''}" alt="${p.title}">
                <span>${p.title}</span>
              </li>`
              );
            });
          }

          // Collections
          if (data.resources.results.collections.length) {
            data.resources.results.collections.forEach((c) => {
              results.push(`<li onclick="window.location='${c.url}'"><span>${c.title}</span></li>`);
            });
          }

          // Pages
          if (data.resources.results.pages.length) {
            data.resources.results.pages.forEach((p) => {
              results.push(`<li onclick="window.location='${p.url}'"><span>${p.title}</span></li>`);
            });
          }

          if (results.length === 0) {
            results.push('<li>No results found</li>');
          }

          html += results.join('') + '</ul>';
          container.innerHTML = html;
          container.style.display = 'block';
        });
    });

    // Hide suggestions when clicking outside
    document.addEventListener('click', function (e) {
      if (!container.contains(e.target) && e.target !== input) {
        container.style.display = 'none';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
